module.exports = __webpack_public_path__ + "img/2025-11-17d_1.e4c3c1cf.jpg";